import React, { useState, useEffect } from 'react';
import '../pages/Mission.css';
import { Check } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { signInWithGoogle, handleRedirectResult } from '../utils/authUtils';
import { useNavigate } from 'react-router-dom';

const Mission = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [authLoading, setAuthLoading] = useState(false);
    const [authError, setAuthError] = useState(null);
    const navigate = useNavigate();
    const { user, authInitialized } = useAuth();

    // Handle redirect result on page load
    useEffect(() => {
        const handleAuthRedirect = async () => {
            if (authInitialized) {
                const redirectResult = await handleRedirectResult();
                if (redirectResult.success && redirectResult.result) {
                    console.log('Redirect authentication successful');
                    navigate(`/main/${redirectResult.result.user.uid}`);
                }
            }
        };

        handleAuthRedirect();
    }, [authInitialized, navigate]);

    // Don't auto-navigate existing users - let them stay on mission page

    const handleSignInWithGoogle = async () => {
        setAuthLoading(true);
        setAuthError(null);
        
        try {
            const result = await signInWithGoogle();
            
            if (result.method === 'popup' && result.result) {
                // For popup method, navigate immediately
                navigate(`/main/${result.result.user.uid}`);
                setShowSignUpModal(false);
            }
            // For redirect method, navigation will happen automatically
        } catch (error) {
            console.error('Authentication error:', error);
            setAuthError(error.message);
        } finally {
            setAuthLoading(false);
        }
    };
    const toggleModal = () => {
        setIsOpen(!isOpen);
    }  


    return (
        <div>
                  <header className="header">
                <div className="header-container">
                    <a href="/" className="logo">
                        <div className="logo-icon">S</div>
                        StudySpace
                    </a>
                    <nav className="nav">
                        <a href="/#features" className="nav-link">Features</a>
                        <a href="/pricing" className="nav-link">Pricing</a>
                        <a href="/mission" className="nav-link">Our Mission</a>
                    </nav>
                    <button onClick={toggleModal} className="sign-in-btn">Sign in</button>
                </div>
            </header>
        <div className="mission-container">
            <h1>Striving to make learning more efficient and effective.</h1>

            <p>Too many students spend hours drowning in generic information through endless results, struggling with one-size-fits-all study guides, losing their own insights in a sea of irrelevant content.</p>
            <p>We believe that learning should be personalized, efficient, and effective. We want to help students learn more effectively and efficiently.</p>
            <p>We want to help students and teachers create a more personalized and effective learning experience.</p>
            <p>Today our platform is the best for creating personalized study guides and quizzes.</p>
            <p>Our goal is simple: make learning feel effortless and enjoyable. With StudySpace, you can create a more personalized and effective learning experience. No more endless results, no more one-size-fits-all study guides, no more losing your own insights in a sea of irrelevant content. We're building the future of learning, one step at a time.</p>

            <p>If you are student or teacher, welcome we're glad to have you here.</p>
            <p>If you are a student, you can use our platform to create personalized study guides and quizzes.</p>
            <p>If you are a teacher, you can use our platform to create personalized study guides and quizzes for your students.</p>
            <p>We're always looking for feedback and suggestions to improve our platform. If you have any ideas, please let us know.</p>
            <p>Happy learning!</p>

           
        </div>


        {isOpen && (
        <div className="modal">
            <div className="modal-content">
                <button className="modal-close" onClick={toggleModal}>×</button>
                
                <h2 className="modal-title">Welcome to StudySpace</h2>
                
                        <button onClick={handleSignInWithGoogle} className="google-btn" disabled={authLoading}>
                    <div className="google-logo">G</div>
                    {authLoading ? 'Signing in...' : 'Continue with Google'}
                </button>
                
                {authError && (
                    <div className="auth-error">
                        {authError}
                    </div>
                )}
                
                <div className="separator">
                    <span>or</span>
                </div>
                
                {/* <input type="email" className="email-input" placeholder="EMAIL" />
                
                <button className="email-btn">Continue with email</button>
                 */}
                <p className="login-link">
                    Have an Account? <button style={{cursor: 'pointer', border: 'none', background: 'none', color: '#3b82f6', fontWeight: '500'}} onClick={handleSignInWithGoogle} disabled={authLoading}>Log In</button>
                </p>
            </div>
        </div>
    )}


        <footer className="footer">
        <div className="footer-container">
            <div className="footer-left">
                <div className="footer-logo">
                    <div className="footer-logo-icon">S</div>
                    <span className="footer-brand">StudySpace</span>
                </div>
                <p className="footer-copyright">© 2025 StudySpace, Boston, MA</p>
{/*                 
                <div className="social-links">
                    <a href="#" className="social-link">
                        <Send className="social-icon" />
                    </a>
                    <a href="#" className="social-link">
                        <Linkedin className="social-icon" />
                    </a>
                    <a href="#" className="social-link">
                        <Youtube className="social-icon" />
                    </a>
                    <a href="#" className="social-link">
                        <Instagram className="social-icon" />
                    </a>
                </div> */}
                
                <div className="footer-status">
                    <Check className="status-icon" />
                    <span>All services are online.</span>
                </div>
            </div>
            
            <div className="footer-right">
                <div className="footer-columns">
                    <div className="footer-column">
                        <a href="/" className="footer-link">Features</a>
                        <a href="/pricing" className="footer-link">Pricing</a>
                        {/* <a href="#" className="footer-link">Blog</a> */}
                        <a href="/mission" className="footer-link">Our Mission</a>
                    </div>
                    {/* <div className="footer-column">
                        <a href="#" className="footer-link">Privacy Policy</a>
                        <a href="#" className="footer-link">Terms of Service</a>
                        <a href="#" className="footer-link">Cookie Policy</a>
                    </div> */}
                </div>
            </div>
        </div>
    </footer>
        </div>
    );
};

export default Mission;